/**
 * Dependency-free deep clone for plain data objects.
 *
 * Uses structuredClone when available (preserves `undefined` and nesting),
 * falling back to a JSON round-trip. Intended for plain data (no functions,
 * Date, Map, etc.) — e.g. block component value objects.
 */
export default function deepClone<T>(value: T): T {
  if (typeof structuredClone === 'function') {
    try {
      return structuredClone(value);
    } catch {
      // value contains something structuredClone can't handle — fall back.
    }
  }
  return JSON.parse(JSON.stringify(value));
}
